import React from "react";
import { APPS } from "../../lib/constants";
import { navigate } from "wouter/use-browser-location";
import { AppIcon } from "../../components/device/AppIcon";
export default function WaitingListPage({ appId }) {
  const popularApps = APPS.filter((app) => app.isPopular);

  function formatAppId(appId) {
    return appId
      // Replace underscores, dashes, dots, and other non-alphanumeric chars with spaces
      .replace(/[_\-.]+/g, " ")
      // Trim spaces at start/end
      .trim()
      // Split by spaces
      .split(" ")
      // Capitalize first letter of each word
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      // Join back with space
      .join(" ");
  }
  

  return (
    <div
      className="font-mono rounded-lg shadow-lg p-6 flex flex-col">
      <div className="items-center justify-center">
        <div className="bg-white border border-[#4F46E5] rounded-2xl p-10 shadow-lg text-center max-w-xl mx-auto">
          <div className="text-yellow-500 text-7xl mb-6">📦</div>
          <h1 className="text-4xl font-extrabold mb-4 text-slate-900">
            The app <span className="font-mono text-indigo-600">{formatAppId(appId)}</span> is not available yet
          </h1>
          <p className="text-slate-600">
            It’s coming soon! <span>or never!!</span>
          </p>
        </div>
      </div>
    <div className="max-w-5xl mx-auto p-6">
      <h2 className="text-3xl font-bold mb-6">Popular Apps</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {popularApps.map((app, index) => (
          <div
            key={app.id}
            onClick={() => navigate(`/app/${app.id}`)}
            className="cursor-pointer rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition"
            style={{ borderColor: app.color, borderWidth: 2 }}
          >
            <div className="text-5xl mb-4">
              <AppIcon app={app} index={index} hideName = {true} />
            </div>
            <h3 className="text-xl font-semibold mb-2">{app.name}</h3>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}
